import { tv } from 'tailwind-variants'

export const messageBubbleVariants = tv({
  slots: {
    container: 'flex max-w-[60%] space-x-deca',
    base: 'flex flex-col p-mili my-micro rounded-t-mili break-words',
    row: 'flex min-w-full space-x-deca items-center'
  },
  variants: {
    source: {
      CLIENT: {
        container: 'self-start justify-start',
        row: 'self-start justify-start',
        base: 'rounded-br-mili bg-secondary-xlight'
      },
      PRODUCT: {
        container: 'self-end justify-end',
        row: 'self-end justify-end',
        base: 'rounded-bl-mili text-white bg-secondary-medium'
      }
    },
    fullWidth: {
      true: {
        base: 'w-full',
        container: 'w-full'
      }
    },
    hasButtons: {
      true: {
        container: 'w-[60%]'
      }
    },
    scroll: {
      true: {
        base: 'transition-colors duration-300 bg-[#fab233]'
      }
    }
  }
})
